// src/pages/NotFound.jsx
import React from "react";
import { Container, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Container sx={{ py: 6, textAlign: "center" }}>
      <Typography variant="h3" sx={{ mb: 2 }}>
        404 – Page Not Found
      </Typography>
      <Typography sx={{ mb: 3, color: "text.secondary" }}>
        The page you’re looking for doesn’t exist.
      </Typography>
      <Button variant="contained" onClick={() => navigate("/")}>
        Go Home
      </Button>
    </Container>
  );
}
